module.exports = __webpack_public_path__ + "static/media/BTN_Play_NotActive.bca51457.svg";